import { render, staticRenderFns } from "./DatosGeneralesForm.vue?vue&type=template&id=19ba196c"
import script from "./DatosGeneralesForm.vue?vue&type=script&lang=js"
export * from "./DatosGeneralesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports